'use strict';

angular.module('atex.art').factory('ArtVersionService',
['$q', '$rootScope',

  function($q, $rootScope) {
    var serviceHandler = atex.VersionServiceHandler(atex.act.AngularUtils.applyingQ($q, $rootScope)),
      cachedVersion;

    return {
      getVersion: function() {
        if(!cachedVersion) {
          cachedVersion = serviceHandler.getVersion();
        }

        return cachedVersion;
      }
    };
  }
]);
